module.exports = __webpack_public_path__ + "img/coin-right.9e815eab.svg";